// What a visitor meets at each row of his vending machine (components/ui/VendingPanel.jsx), kept apart from the panel
// so it can be tested: who a row is for, what it costs them, and whether it can be had now, or why not (28 Oct).

export const price = (p) => (p < 100 ? `${p}p` : `£${(p / 100).toFixed(p % 100 ? 2 : 0)}`)

// his two packs, for them: what the screen says of each
export const FOR_YOU = {
  print: { label: 'random print', title: 'RANDOM PRINT', lines: ['ONE OF HIS DRAWINGS, AT RANDOM, POSTED', 'TO YOU. YOU SEE WHICH WHEN IT DROPS.'] },
  stickers: { label: 'sticker pack', title: 'STICKER PACK', lines: ['SIX DIE-CUT STICKERS OF HIS DRAWINGS,', 'CATS AND HIMSELF, AT RANDOM, POSTED TO YOU.'] },
}

/** Each row as a visitor meets it: who it is for, what it costs them, and whether it can be had now (or why not). */
export function keysOf(data) {
  const v = data?.visitor || {}
  const giftsOpen = !!v.gifts?.available
  return (data?.rows || []).map((r) => {
    if (r.kind === 'visitor') {
      const which = r.forVisitors === 'print' ? 'print' : 'stickers'
      const till = v[which] || {}
      return { code: r.code, forYou: which, label: FOR_YOU[which].label, pence: till.pence || 1000, can: !!till.available, why: till.available ? null : which === 'print' ? 'THE PRINTS ARE ALL GONE' : 'NO STICKERS IN TODAY' }
    }
    const why = r.kind === 'empty' ? 'AN EMPTY SPIRAL' : r.stuck ? 'STUCK ON ITS SPIRAL' : r.soldOut || !r.stock ? (r.kind === 'cassette' ? 'NOT IN YET' : 'SOLD OUT') : !giftsOpen ? 'THE TILL IS SHUT' : !r.gift ? 'NOT FOR SALE' : null
    return { code: r.code, label: r.label || String(r.name || '').replace(/^(a|an) /, ''), pence: r.gift || 0, can: !why, why, stuck: !!r.stuck, soldOut: !!r.soldOut || r.kind === 'empty' }
  })
}

